module.exports = __webpack_public_path__ + "static/media/reception8.a9342f07.jpg";